module.exports = __webpack_public_path__ + "img/huelva-full.4a11b1e8.png";